import { create } from 'zustand';

interface ContactFallbackStore {
  email: string;
  phoneNumber: string;
  setEmail: (email: string) => void;
  setPhoneNumber: (phoneNumber: string) => void;
  reset: () => void;
}

const useContactFallbackStore = create<ContactFallbackStore>((set) => ({
  email: '',
  phoneNumber: '',
  setEmail: (email) => set({ email }),
  setPhoneNumber: (phoneNumber) => set({ phoneNumber }),
  reset: () => set({ email: '', phoneNumber: '' })
}));

export const useContactFallbackEmail = () => useContactFallbackStore((state) => state.email);
export const useContactFallbackPhoneNumber = () => useContactFallbackStore((state) => state.phoneNumber);

export const useContactFallbackActions = () => {
  const setEmail = useContactFallbackStore((state) => state.setEmail);
  const setPhoneNumber = useContactFallbackStore((state) => state.setPhoneNumber);
  const reset = useContactFallbackStore((state) => state.reset);
  return { setEmail, setPhoneNumber, reset };
};
